import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';
import Toggle from 'react-toggle';
import getLocale from '../../../i18n/getLocale';

class BasesEditTab extends Component {
  constructor(props) {
    super(props);

    // Handlers

    this.locale = getLocale();

    //

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      id: this.props.base_id,
      staff_list: [],
      sigmec_bases: [],
      bases_rubi: [],
      base_dates: [],
      cost_centers: [],
      cost_centers_select: [],
      base_companies: [],
      companies_select: [],
      name: this.props.base_data.name,
      abbreviation: this.props.base_data.abbreviation,
      iata_code: this.props.base_data.iata_code,
      daily: 0,
      order: null,
      transportation: 0,
      deslocation: 0,
      active: 0,
      city: this.props.base_data.city,
      uf: this.props.base_data.uf,
      zipcode: this.props.base_data.zipcode,
      phone:this.props.base_data.phone,
      observations: this.props.base_data.observations,
      email: this.props.base_data.email,
      force_daily: this.props.base_data.force_daily,
      sigmec_id: this.props.base_data.sigmec_id,
      role_types_select: [
        {value: 'crew', label: this.locale.Bases.EditarBase.tabDadosDaBase.tiposDeCargo.Tripulacao},
        {value: 'cvo', label: this.locale.Bases.EditarBase.tabDadosDaBase.tiposDeCargo.CVODVO},
        {value: 'master', label: this.locale.Bases.EditarBase.tabDadosDaBase.tiposDeCargo.MestreCarga},
        {value: 'mechanic', label: this.locale.Bases.EditarBase.tabDadosDaBase.tiposDeCargo.Mecanico},
        {value: 'management', label: this.locale.Bases.EditarBase.tabDadosDaBase.tiposDeCargo.Administrativo},
        {value: 'indirect', label: this.locale.Bases.EditarBase.tabDadosDaBase.tiposDeCargo.Indireto},
      ],
    };

    //bind específico
    this.edit = this.edit.bind(this);
    this.addCode = this.addCode.bind(this);
    this.deleteCode = this.deleteCode.bind(this);
    this.addDate = this.addDate.bind(this);
    this.deleteDate = this.deleteDate.bind(this);
    this.addCostCenter = this.addCostCenter.bind(this);
    this.deleteCostCenter = this.deleteCostCenter.bind(this);

    this.addCompany = this.addCompany.bind(this);
    this.deleteCompany = this.deleteCompany.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  // LM
  componentWillReceiveProps(newProps) {
    if(typeof this.state.name === 'undefined' && typeof newProps.base_data.name !== 'undefined') {
      this.setState({
        id: newProps.base_id,
        name: newProps.base_data.name,
        abbreviation: newProps.base_data.abbreviation,
        iata_code: newProps.base_data.iata_code,
        daily: newProps.base_data.daily_str,
        transportation: newProps.base_data.transportation,
        deslocation: newProps.base_data.deslocation,
        city: newProps.base_data.city,
        uf: newProps.base_data.uf,
        zipcode: newProps.base_data.zipcode,
        active: newProps.base_data.active,
        phone: newProps.base_data.phone,
        order: newProps.base_data.order,
        observations: newProps.base_data.observations,
        email: newProps.base_data.email,
        force_daily: newProps.base_data.force_daily,
        sigmec_id: newProps.base_data.sigmec_id,
      });
    }
    if(Array.isArray(newProps.companies_select) && (this.state.loaded === 0)) {
      this.setState({companies_select: newProps.companies_select});
    }
    if(Array.isArray(newProps.base_companies) && (this.state.loaded === 0)) {
      this.setState({base_companies: newProps.base_companies});
    }
    if(Array.isArray(newProps.staff_list) && (this.state.loaded === 0)) {
      this.setState({staff_list: newProps.staff_list});
    }
    if(Array.isArray(newProps.sigmec_bases) && (this.state.loaded === 0)) {
      this.setState({sigmec_bases: newProps.sigmec_bases});
    }
    if(Array.isArray(newProps.bases_rubi) && (this.state.loaded === 0)) {
      this.setState({bases_rubi: newProps.bases_rubi});
    }
    if(Array.isArray(newProps.base_dates) && (this.state.loaded === 0)) {
      this.setState({base_dates: newProps.base_dates});
    }
    if(Array.isArray(newProps.cost_centers) && this.state.cost_centers.length === 0 && (this.state.loaded === 0)) {
      this.setState({cost_centers: newProps.cost_centers});
    }
    if(Array.isArray(newProps.cost_centers_select) && this.state.cost_centers_select.length === 0 && (this.state.loaded === 0)) {
      this.setState({cost_centers_select: newProps.cost_centers_select});
    }
  }

  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      name: this.state.name,
      abbreviation: this.state.abbreviation,
      iata_code: this.state.iata_code,
      daily: this.state.daily,
      transportation: this.state.transportation,
      deslocation: this.state.deslocation,
      city: this.state.city,
      uf: this.state.uf,
      zipcode: this.state.zipcode,
      active: this.state.active,
      phone: this.state.phone,
      order: this.state.order,
      observations: this.state.observations,
      email: this.state.email,
      force_daily: this.state.force_daily,
      sigmec_id: this.state.sigmec_id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/base', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // Fetch salvando a edição
  addCode(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      base_id: this.state.id,
      rubi_code: this.state.rubi_code,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/rubi/base', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState({ loaded: 1 });
        self.setState({bases_rubi: responseJson.data});
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // Fetch salvando a edição
  deleteCode(id) {
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/rubi/base/' + id, { method: 'DELETE', mode: 'cors', headers: value, }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState({ loaded: 1 });
        self.setState({bases_rubi: responseJson.data});
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

    // Fetch salvando a edição
    addCompany(event) {
      event.preventDefault();
      this.props.handleAlert('', '', 'open');
      var datasave = {
        base_id: this.state.id,
        company_id: this.state.company_id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/base/empresa', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if(responseJson.status === 'success') {
            self.setState({ loaded: 1 });
            self.setState({base_companies: responseJson.data});
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }

    // Fetch salvando a edição
    deleteCompany(id) {
      if (window.confirm(this.locale.Bases.EditarBase.tabDadosDaBase.deletarEmpresa)) {
        this.props.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/base/empresa/' + id, { method: 'DELETE', mode: 'cors', headers: value, }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            self.setState({ loaded: 1 });
            self.setState({base_companies: responseJson.data});
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch((error) => {
            console.error(error);
          });
        });
      }
    }


    // Fetch salvando a edição
    addDate(event) {
      event.preventDefault();
      this.props.handleAlert('', '', 'open');
      var datasave = {
        base_id: this.state.id,
        date: this.state.date,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/data/base', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({ loaded: 1 });
          self.setState({base_dates: responseJson.data});
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  
    // Fetch salvando a edição
    deleteDate(id) {
      if (window.confirm(this.locale.Bases.EditarBase.tabDadosDaBase.deletarData)) {
        this.props.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/data/base/' + id, { method: 'DELETE', mode: 'cors', headers: value, }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            self.setState({ loaded: 1 });
            self.setState({base_dates: responseJson.data});
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch((error) => {
            console.error(error);
          });
        });
      }
    }

    
  // Fetch salvando a edição
  addCostCenter(event) {
    event.preventDefault();
    var self = this;
    self.props.handleAlert('', '', 'open');
    var datasave = {
      base_id: this.state.id,
      cost_center_id: this.state.cost_center_id,
      role_type: this.state.role_type,
    };
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/base/centro/custo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if(responseJson.status === 'success') {
          self.setState({ cost_centers: responseJson.data });
        }
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // Fetch salvando a edição
  deleteCostCenter(id) {
    if(window.confirm(this.locale.Bases.EditarBase.tabDadosDaBase.deletarCentroDeCusto)) {
      var self = this;
      self.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/base/centro/custo/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if(responseJson.status === 'success') {
            self.setState({ cost_centers: responseJson.data });
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <form onSubmit={this.edit}>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Bases.EditarBase.tabDadosDaBase.formulario.Nome}:</label>
          <input type="text" name="name" className="form-control" placeholder={this.locale.Bases.EditarBase.tabDadosDaBase.formulario.placeholder.NomeDaBase} value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Bases.EditarBase.tabDadosDaBase.formulario.CodigoICAO}:</label>
          <input type="text" name="abbreviation" className="form-control" placeholder={this.locale.Bases.EditarBase.tabDadosDaBase.formulario.placeholder.CodigoICAO} value={this.state.abbreviation} onChange={this.handleChange.bind(this, 'abbreviation')} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Bases.EditarBase.tabDadosDaBase.formulario.CodigoIATA}:</label>
          <input type="text" name="iata_code" className="form-control" placeholder={this.locale.Bases.EditarBase.tabDadosDaBase.formulario.placeholder.CodigoIATA} value={this.state.iata_code} onChange={this.handleChange.bind(this, 'iata_code')} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Bases.EditarBase.tabDadosDaBase.formulario.Cidade}:</label>
          <input type="text" name="city" className="form-control" placeholder={this.locale.Bases.EditarBase.tabDadosDaBase.formulario.placeholder.CidadeDaBase} value={this.state.city} onChange={this.handleChange.bind(this, 'city')} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Bases.EditarBase.tabDadosDaBase.formulario.Estado}:</label>
          <Select
            className="form-field-name"
            name="uf"
            value={this.state.uf}
            searchable={true}
            placeholder={this.locale.Bases.EditarBase.tabDadosDaBase.formulario.placeholder.EstadoDaBase}
            onChange={this.handleSelectChange.bind(this, 'uf')}
            options={[
              {value: "AC", label: "Acre"},
              {value: "AL", label: "Alagoas"},
              {value: "AM", label: "Amazonas"},
              {value: "AP", label: "Amapá"},
              {value: "BA", label: "Bahia"},
              {value: "CE", label: "Ceará"},
              {value: "DF", label: "Distrito Federal"},
              {value: "ES", label: "Espírito Santo"},
              {value: "GO", label: "Goiás"},
              {value: "MA", label: "Maranhão"},
              {value: "MT", label: "Mato Grosso"},
              {value: "MS", label: "Mato Grosso do Sul"},
              {value: "MG", label: "Minas Gerais"},
              {value: "PA", label: "Pará"},
              {value: "PB", label: "Paraíba"},
              {value: "PR", label: "Paraná"},
              {value: "PE", label: "Pernambucano"},
              {value: "PI", label: "Piauí"},
              {value: "RJ", label: "Rio de Janeiro"},
              {value: "RN", label: "Rio Grande do Norte"},
              {value: "RO", label: "Rondônia"},
              {value: "RS", label: "Rio Grande do Sul"},
              {value: "RR", label: "Roraima"},
              {value: "SC", label: "Santa Catarina"},
              {value: "SE", label: "Sergipe"},
              {value: "SP", label: "São Paulo"},
              {value: "TO", label: "Tocantins"},
            ]}
          />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Bases.EditarBase.tabDadosDaBase.formulario.CEP}:</label>
          <InputMask value={this.state.zipcode}  maskChar={null} name="zipcode" mask="99999-999" className="form-control" onChange={this.handleChange.bind(this, 'zipcode')} placeholder={this.locale.Bases.EditarBase.tabDadosDaBase.formulario.placeholder.CEPdaBase} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Bases.EditarBase.tabDadosDaBase.formulario.Telefone}:</label>
          <InputMask value={this.state.phone}  maskChar={null} name="phone" mask="(99) 9999-99999" className="form-control" onChange={this.handleChange.bind(this, 'phone')} placeholder={this.locale.Bases.EditarBase.tabDadosDaBase.formulario.placeholder.TelefoneDaBase} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Bases.EditarBase.tabDadosDaBase.formulario.Ordem}:</label>
          <input value={this.state.order} name="order" className="form-control" onChange={this.handleChange.bind(this, 'order')} placeholder={this.locale.Bases.EditarBase.tabDadosDaBase.formulario.placeholder.OrdemDaBase} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Bases.EditarBase.tabDadosDaBase.formulario.Email}:</label>
          <input value={this.state.email} type="text" name="email" className="form-control" onChange={this.handleChange.bind(this, 'email')} placeholder={this.locale.Bases.EditarBase.tabDadosDaBase.formulario.placeholder.Email} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Bases.EditarBase.tabDadosDaBase.formulario.Ativa}:</label>
          <br/>
          <Toggle
            defaultChecked={this.state.active}
            checked={this.state.active}
            aria-label='No label tag'
            name="active"
            onChange={this.handleToggleChange.bind(this, 'active')} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-12">
        <div className="form-group">
          <label>{this.locale.Bases.EditarBase.tabDadosDaBase.formulario.Observacoes}:</label>
          <textarea style={{ height: 200 }} type="text" name="observations" className="form-control" value={this.state.observations} onChange={this.handleChange.bind(this, 'observations')} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-12">
        <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Bases.EditarBase.tabDadosDaBase.formulario.botaoSalvarEdicao}</button>
      </div>
    </div>
  </form>
</div>
    );
  }
}

export default BasesEditTab;


// WEBPACK FOOTER //
// ./src/Components/Bases/Elements/BasesEditTab.js